import './App.css';
import React from 'react';
import Home from './views/pages/home-page';
import { createBrowserRouter, Route, createRoutesFromElements, RouterProvider } from 'react-router-dom';
import Root from './views/root';
import Contact from './views/pages/contact';
import Gallery from './views/pages/gallery';
import ArticleEditor from './views/pages/article-editor';
import LoginPage from './views/pages/login-page';
import ArticlePage from './views/pages/article-page';
import Articles from './views/pages/articles';
import AppsPage from './views/pages/apps-page';


const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<Root />}>
      <Route path='/' element={<Home />} />
      <Route path="/pages/contact" element={<Contact />} />
      <Route path="/pages/gallery" element={<Gallery />} />
      <Route path="/pages/login" element={<LoginPage />} /> 
      
      <Route path="/pages/article_editor/" element={<ArticleEditor />} />
      <Route path="/pages/article_editor/:id" element={<ArticleEditor />} />
      <Route path='/pages/article/:id' element={<ArticlePage />} />
      <Route path='/pages/articles' element={<Articles />} />
      <Route path="/pages/apps" element={<AppsPage />} />
    </Route>
  )
)

function App() {
  return (
      <RouterProvider router={router}></RouterProvider>
  );
}

export default App;
